// Copyright (c) 2022 by Move Closer

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export enum AllowedImageRatio {
  Original = 'original',
  Square = 'square'
}

export enum AllowedImageWidth {
  ProductCardSmall = 350,
  ProductCard = 670,
  ProductFull = 1100,
  ProductListBanner = 640,
  BrandLogo = 580,
  BrandBanner = 580,
  FullWidth = 1920
}
